import {
    FunctionComponent,
    ReactNode,
    useCallback,
    useEffect,
    useState
} from 'react';
import {Account} from '../features/accounts/types';
import {fetch as fetchAccount} from "../features/accounts/services/AccountsService.ts";
import {UserAccountContext} from '../context/UserAccountContext.tsx';
import {useUserAttributes} from "../hooks/useUserAttributes.ts";


interface IUserAccountProvider {
    children?: ReactNode
}

export const UserAccountProvider: FunctionComponent<IUserAccountProvider> = ({children}) => {

    const [userAccount, setUserAccount] = useState<Account | undefined>(undefined);

    const attributes = useUserAttributes();

    const fetchUserAccount = useCallback(async () => {
        try {
            const result = await fetchAccount(attributes?.accountId as string)
            setUserAccount(result || undefined)

        } catch (error) {
            console.trace(
                'USER ACCOUNT CONTEXT. FETCH USER ERROR',
                error
            );
        }
    }, [attributes]);

    useEffect(() => {
        if (!attributes?.accountId) {
            return;
        }
        fetchUserAccount();
    }, [attributes.accountId]);


    return (
        <UserAccountContext.Provider value={{
            userAccount,
        }}>
            {children}
        </UserAccountContext.Provider>
    );
};
